import React from 'react';

import svg from './assets/icons-16-filter.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconFilter = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-filter" />
);
